export var $listings = $('.result-item[clickable="true"]');